import {
  DEFAULT_MONTHLY_TRENDING_COMPARATIVE_VIEW,
  MonthlyTrendingComparativeViewValues,
  type MonthlyTrendingComparativeView,
} from '@erp/shared-types';

export function comparativeViewFromShareMetadata(
  locked?: string,
): MonthlyTrendingComparativeView {
  if (
    locked === MonthlyTrendingComparativeViewValues.REPORTED ||
    locked === MonthlyTrendingComparativeViewValues.CURRENT
  ) {
    return locked;
  }
  return DEFAULT_MONTHLY_TRENDING_COMPARATIVE_VIEW;
}

export function comparativeViewShareMetadata(
  view: MonthlyTrendingComparativeView,
): { comparativeView: [MonthlyTrendingComparativeView] } {
  return { comparativeView: [view] };
}
